import {createStore} from 'vuex'

// Helper functions for localStorage persistence
const STORAGE_KEY = 'goalRushVuexStore';

function loadState() {
    try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : undefined;
    } catch (e) {
        return undefined;
    }
}

function saveState(state) {
    try {
        // Only save serializable state, and exclude brandConfig
        const { brandConfig, ...stateToSave } = state;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    } catch (e) {}
}

const initialState = loadState() || {
    isLoading: false,
    userScore: false,
    user: undefined,
    encryptedMsisdn: undefined,
    token: undefined,
    msisdn: undefined,
    userQuizFinishingTime: undefined,
    brandConfig: undefined,
    burgerMenuIconVisible: false,
    campaignId: null,
    googleClickId: undefined,
    leaderboardSmsReminderPopup: false,
    coolDownTimerPopup: false,
    evinaToken: undefined,
    evinaScript: undefined,
    subscriptionPackage: undefined,
    serviceId: undefined,
};

const store = createStore({
    state: initialState,
    mutations: {
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
        setUserScore(state, userScore) {
            state.userScore = userScore
        },
        setUser(state, user) {
            state.user = user
        },
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
        },
        setEncryptedMsisdn(state, encryptedMsisdn) {
            state.encryptedMsisdn = encryptedMsisdn
        },
        setToken(state, token) {
            state.token = token
        },
        setUserQuizFinishingTime(state, userQuizFinishingTime) {
            state.userQuizFinishingTime = userQuizFinishingTime
        },
        setBrandConfig(state, brandConfig) {
            state.brandConfig = brandConfig
        },
        setBurgerMenuIconVisible(state, burgerMenuIconVisible) {
            state.burgerMenuIconVisible = burgerMenuIconVisible
        },
        setCampaignId(state, campaignId) {
            state.campaignId = campaignId
        },
        setGoogleClickId(state, googleClickId) {
            state.googleClickId = googleClickId
        },
        setLeaderboardSmsReminderPopup(state, leaderboardSmsReminderPopup) {
            state.leaderboardSmsReminderPopup = leaderboardSmsReminderPopup
        },
        setEvinaToken(state, evinaToken) {
            state.evinaToken = evinaToken
        },
        setEvinaScript(state, evinaScript) {
            state.evinaScript = evinaScript
        },
        setCoolDownTimerPopup(state, coolDownTimerPopup) {
            state.coolDownTimerPopup = coolDownTimerPopup
        },
        setSubscriptionPackage(state, subscriptionPackage) {
            state.subscriptionPackage = subscriptionPackage
        },
        setServiceId(state, serviceId) {
            state.serviceId = serviceId
        },
    },
    actions: {},
    modules: {}
});

// Subscribe to store mutations to persist state
store.subscribe((mutation, state) => {
    saveState(state);
});

export default store;
